import React, { useContext, useState } from "react";

import { Grid, makeStyles, Paper } from "@material-ui/core";
import { InputTextArea, InputTextMaster, MasterButton } from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import InputFileCustom from "App/Component/ui/input/InputFileCustom/InputFileCustom";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { FORM_RESET_STATE_DETAIL } from "../../helpers";
import {
  DEFAULT_BOX_SHADOW,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  PRIMARY_BACKGROUND,
} from "App/constants";
import ListFixedAsset from "./ListFixedAsset";
import Title from "App/Component/ui/title/Title";
export default function FormReq({ setNewDataReqList }) {
  const { formData, formDetail, setFormDetail } = useContext(FormContext);
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const useStyles = makeStyles({
    root: {
      width: "auto",
    },
    paper: {
      width: "100%",
      margin: "0",
      padding: "1rem 1.5rem",
      backgroundColor: PRIMARY_BACKGROUND,
      boxShadow: DEFAULT_BOX_SHADOW,
    },
    table: {
      width: "100%",
      margin: "0 auto",
      overflow: "auto",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    textRed: {
      color: "red",
    },
    border: {
      paddingTop: "10px",
      borderBottom: "1.5px dashed #333333",
    },
  });
  const classes = useStyles();
  const handleClickSubmit = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        isNull(formData.id) ||
        isNull(formDetail.fixasset_id) ||
        isNull(formDetail.fixasset_name) ||
        isNull(formDetail.fixasset_code)
      ) {
        defaultToastError("Harap lengkapi form terlebih dahulu !");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        const newFormData = new FormData();
        newFormData.append("id_helpdesk_header", formData.id);
        newFormData.append("fixasset_id", formDetail.fixasset_id);
        newFormData.append("nama_asset", formDetail.fixasset_name);
        newFormData.append("code_asset", formDetail.fixasset_code);
        newFormData.append("remark", formDetail.remark);
        newFormData.append("uploadFile", file);

        const api = await instance4.post(
          "/wmsAsset/helpdesk/add-detail",
          newFormData
        );
        const res = api.data;
        console.log("Reas Add", res);
        if (res.status === 200) {
          console.log("Add Ok");
          await setNewDataReqList(formData.id);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          defaultToastSuccess(res.message);
          setFile(null);
          setFormDetail(FORM_RESET_STATE_DETAIL);
        } else {
          defaultToastError(res.message);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickSelectAsset = (row) => {
    if (!isNull(formData.id)) {
      setFormDetail({
        ...formDetail,
        fixasset_id: row?.id,
        fixasset_name: row?.name,
        fixasset_code: row?.code,
      });
    }
  };

  const handleChange = (text) => (e) => {
    setFormDetail({
      ...formDetail,
      [text]: e.target.value,
    });
  };

  return (
    <>
      <Grid container spacing={2} alignItems="stretch" direction="row">
        <Grid item sm={6}>
          <form action="">
            <Paper
              className={classes.paper}
              style={{
                padding: "1rem 1.5rem",
                minHeight: "262px",
              }}
            >
              <Title subtitle={"FORM PERMINTAAN"} />
              <Grid container spacing={1}>
                <Grid item sm={12}>
                  <InputTextMaster
                    name="id"
                    label="ID"
                    id="id"
                    placeholder=""
                    disabled={true}
                    value={formDetail.id}
                  />
                </Grid>
                <Grid item sm={12}>
                  <InputTextMaster
                    name="id"
                    label="ID FIXED ASSET"
                    id="id"
                    placeholder="-"
                    disabled={true}
                    value={formDetail.fixasset_id}
                  />
                </Grid>
                <Grid item sm={12}>
                  <InputTextMaster
                    name="code"
                    label="NAMA FIXED ASSET"
                    id="code"
                    value={formDetail.fixasset_name}
                    readOnly={true}
                    disabled={true}
                    placeholder="-"
                  />
                </Grid>
                <Grid item sm={12}>
                  <InputTextMaster
                    name="code"
                    label="KODE FIXED ASSET"
                    id="code"
                    value={formDetail.fixasset_code}
                    readOnly={true}
                    disabled={true}
                    placeholder="-"
                  />
                </Grid>

                <Grid item sm={12}>
                  <InputTextArea
                    name="keterangan"
                    label="KETERANGAN"
                    id="keterangan"
                    placeholder="KETERANGAN"
                    value={formDetail.remark}
                    rows={6}
                    onChange={handleChange("remark")}
                  />
                </Grid>

                <Grid item sm={12}>
                  <label style={{ fontSize: "10px" }}>FILE PENDUKUNG</label>
                  <InputFileCustom
                    style={{ display: "none" }}
                    convertToBase64={false}
                    label={"Upload File"}
                    name={"fileFILE"}
                    id={"fileFILE"}
                    initialNameFile={file}
                    setFile={setFile}
                    accept={".jpg, .jpeg, .png, .xlsx, .docx, .pdf"}
                  />
                  <label
                    style={{
                      // position: "absolute",
                      // left: "8px",
                      fontWeight: 400,
                      color: "#BDBDBD",
                      fontSize: "11px",
                    }}
                  >
                    *File yang diizinkan .jpg, .jpeg, .png, .xlsx, .docx, dan
                    .pdf; Maksimal file berukuran 2MB
                  </label>
                </Grid>
                <Grid item sm={12}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MasterButton
                      name={"RESET"}
                      outline={true}
                      color={"danger"}
                      type={"button"}
                      size={"md"}
                      onClick={() => setFormDetail(FORM_RESET_STATE_DETAIL)}
                    />
                    <MasterButton
                      color={disabled.color}
                      name={disabled.label}
                      disabled={disabled.disabled}
                      outline={true}
                      onClick={handleClickSubmit}
                      type={"button"}
                      size={"md"}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </form>
        </Grid>

        <Grid item sm={6}>
          <Paper
            className={classes.paper}
            style={{
              padding: "1rem 1.5rem",
              minHeight: "262px",
            }}
          >
            <ListFixedAsset
              clickSelectHandler={handleClickSelectAsset}
              formData={formData}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
